import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class SourcesService {
  private sources = new ReplaySubject<any>(1);
  private sourcesPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateSources = (params: any) => {
    var path = `/sources`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.sources.next(data)
        return data
      })
    )
  }

  public getSources = (): Observable<any> => {
    return this.sources.asObservable()
  }

  public updateSourcesPicker = () => {
    var path = `sources`
    return this.cms.request('GET', path).pipe(
      first(),
      map(data => {
        this.sourcesPicker.next(data)
        return data
      })
    )
  }

  public getSourcesPicker = (): Observable<any> => {
    return this.sourcesPicker.asObservable()
  }
}
